/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDirectoryResponseFromDiscriminatorValue, createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, serializeDirectoryResponse, serializeDirectoryUpdateRequest, type DirectoryResponse, type DirectoryUpdateRequest, type HttpValidationProblemDetails, type IError } from '../../models/index.js';
// @ts-ignore
import { ArchiveRequestBuilderRequestsMetadata, type ArchiveRequestBuilder } from './archive/index.js';
// @ts-ignore
import { ChildrenRequestBuilderRequestsMetadata, type ChildrenRequestBuilder } from './children/index.js';
// @ts-ignore
import { CopyRequestBuilderRequestsMetadata, type CopyRequestBuilder } from './copy/index.js';
// @ts-ignore
import { MoveRequestBuilderRequestsMetadata, type MoveRequestBuilder } from './move/index.js';
// @ts-ignore
import { RestoreRequestBuilderRequestsMetadata, type RestoreRequestBuilder } from './restore/index.js';
// @ts-ignore
import { SharesRequestBuilderNavigationMetadata, SharesRequestBuilderRequestsMetadata, type SharesRequestBuilder } from './shares/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /directories/{directory-id}
 */
export interface DirectoryItemRequestBuilder extends BaseRequestBuilder<DirectoryItemRequestBuilder> {
    /**
     * The archive property
     */
    get archive(): ArchiveRequestBuilder;
    /**
     * The children property
     */
    get children(): ChildrenRequestBuilder;
    /**
     * The copy property
     */
    get copy(): CopyRequestBuilder;
    /**
     * The move property
     */
    get move(): MoveRequestBuilder;
    /**
     * The restore property
     */
    get restore(): RestoreRequestBuilder;
    /**
     * The shares property
     */
    get shares(): SharesRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     delete(requestConfiguration?: RequestConfiguration<DirectoryItemRequestBuilderDeleteQueryParameters> | undefined) : Promise<void>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DirectoryResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<DirectoryResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DirectoryResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     put(body: DirectoryUpdateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<DirectoryResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<DirectoryItemRequestBuilderDeleteQueryParameters> | undefined) : RequestInformation;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: DirectoryUpdateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
export interface DirectoryItemRequestBuilderDeleteQueryParameters {
    recursive?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const DirectoryItemRequestBuilderUriTemplate = "{+baseurl}/directories/{directory%2Did}{?recursive*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const DirectoryItemRequestBuilderNavigationMetadata: Record<Exclude<keyof DirectoryItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    archive: {
        requestsMetadata: ArchiveRequestBuilderRequestsMetadata,
    },
    children: {
        requestsMetadata: ChildrenRequestBuilderRequestsMetadata,
    },
    copy: {
        requestsMetadata: CopyRequestBuilderRequestsMetadata,
    },
    move: {
        requestsMetadata: MoveRequestBuilderRequestsMetadata,
    },
    restore: {
        requestsMetadata: RestoreRequestBuilderRequestsMetadata,
    },
    shares: {
        requestsMetadata: SharesRequestBuilderRequestsMetadata,
        navigationMetadata: SharesRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const DirectoryItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: DirectoryItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, application/problem+json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
    get: {
        uriTemplate: DirectoryItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createDirectoryResponseFromDiscriminatorValue,
    },
    put: {
        uriTemplate: DirectoryItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createDirectoryResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeDirectoryUpdateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
